'use strict';

goog.provide("Ntry.MazeStaticIntro");

Ntry.MazeStaticIntro = function() {
    this._popupHelper = new Entry.popupHelper(true);
    this._introPopup = new entrylms.Modal();
};

(function(p){
    p.loadConfig = function () {
        this._intro = Ntry.configManager.getConfig('intro');
        if (this._intro)
            this.fillContent();
    };

    p.remove = function () {
        this._introPopup.off();
        delete this._popupHelper;
        delete this._introPopup;
    }

    p.fillContent = function() {
        var intro = this._intro;
        var stageId = Ntry.configManager.getConfig("stageId");
        var modeId = Ntry.configManager.getConfig("modeId");
        var introData = Ntry.configManager.getConfig("introData");

        var content;
        if(introData) {
            content = introData.items.map(function(item) {
                item.type = 'INTRO';
                item.title = Lang.Menus.start;
                return item;
            });
        } else {
            content =  {
                type: 'INTRO',
                title: Lang.Menus.start,
                content: intro.content,
            };
        }

        this._introPopup.modalData = content;

        // 메이즈 헬프 팝업 띄우는 로직 제거
        // 주석 해제 하면 해당 헬프 팝업 보여줄수 있음
        // this._introPopup.on('hide', function () {
        //     var isHelpPopup = false;
        //     var mode = modeId;
        //     if (modeId == 1 && (stageId == 1 || stageId == 11)) {
        //         isHelpPopup = true;
        //     } else if (modeId == 3 && (stageId == 1 || stageId == 8 || stageId == 13)) {
        //         isHelpPopup = true;
        //         mode = 2;
        //     } else if (modeId == 5 && (stageId == 1 || stageId == 3 || stageId == 4 || stageId == 9)) {
        //         isHelpPopup = true;
        //     }
        //     if(isHelpPopup) {
        //         this.setHelpPopup(mode, stageId);
        //         this._popupHelper.show('mazeHelp');
        //     }
        // }.bind(this));

        this._introPopup.show();
    };

    p.setHelpPopup = function(modeId, stageId) {
        this._popupHelper.addPopup('mazeHelp', {
            title: Lang.Menus.mission_guide,
            setPopupLayout: function(popup) {
                var content = Entry.Dom('div', {
                    class: 'helpImage helpImage_' + modeId + '_' + stageId,
                });
                popup.append(content);
            }
        });
    }

})(Ntry.MazeStaticIntro.prototype);
